import { useLocation, Link } from "react-router-dom";
import SEO from "@/components/feature/SEO";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SEO
        title="Página no encontrada | Ventra Core"
        description="La página que buscas no existe. Explora nuestros servicios de HVAC, climatización y energía UPS en Ventra Core."
        noindex
        canonical={`https://ventracore.com.mx${location.pathname}`}
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://ventracore.com.mx/404#webpage",
            "url": "https://ventracore.com.mx/404",
            "name": "Página no encontrada | Ventra Core",
            "isPartOf": { "@id": "https://ventracore.com.mx/#website" },
          },
        ]}
      />
      <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <h2 className="text-xl md:text-2xl font-semibold mt-6">Página no encontrada</h2>
          <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
          <Link to="/" className="mt-4 inline-block text-brandgreen hover:text-brandgreen-dark font-medium transition-colors">
            Volver al inicio
          </Link>
        </div>
      </div>
    </>
  );
}